import React from 'react';

export const PageHeader = ({ 
  title, 
  subtitle,
  className = '' 
}) => {
  return (
    <header className={`page-header ${className}`}>
      <div className="editorial-container">
        <h1 className="text-balance">{title}</h1>
        {subtitle && (
          <p className="subtitle">{subtitle}</p>
        )}
      </div>
    </header>
  );
};

export default PageHeader;
